import { render, staticRenderFns } from "./ExternalView.vue?vue&type=template&id=63557c77"
import script from "./ExternalView.vue?vue&type=script&lang=js"
export * from "./ExternalView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports